import { createRequestActions } from 'src/lib/requestActions';
import { CommonFiltersDTO } from 'src/app/common/models/commonFiltersDTO';

export const commonFiltersActions = createRequestActions(
  `app/commonFilters/request`,
  `app/commonFilters/requestSuccess`,
  `app/commonFilters/requestFailure`
)<void, CommonFiltersDTO, Record<string, unknown>>();
